import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const SerieNumeroFormGroup = ({ fIsSubmitting, iErrorSerie, iTouchedSerie, iErrorNumero, iTouchedNumero, vTipoDocumento }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-numeroDocumento', e)
  }, [])

  const onKeyDown2 = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-moneda', e)
  }, [])

  // Cuando el tipo de documento es "00 - OTROS/TICKET" la serie no se solicita
  // (se asigna "ALM" por defecto al guardar). Ocultamos el campo y mostramos solo
  // el número, como ya hace Inventarios Entrada/Salida.
  const esOtros = vTipoDocumento === '00'

  return (
    <>
      <Form.Group>
        <Form.Label text={esOtros ? 'NUMERO' : 'SERIE'} htmlFor={esOtros ? 'input-numeroDocumento' : 'input-serieDocumento'} md={4} alignRightAt='md' />
        {!esOtros && (
          <Col md={4}>
            <Field name='serieDocumento'>
              {({ field }) => (
                <Form.InputText
                  {...field}
                  id='input-serieDocumento'
                  disabled={fIsSubmitting}
                  className='zr-text-upper'
                  isInvalid={iTouchedSerie && iErrorSerie}
                  maxLength={4}
                  onKeyDown={onKeyDown}
                />
              )}
            </Field>
            {iTouchedSerie && iErrorSerie ? <Form.Feedback type='invalid'>{iErrorSerie}</Form.Feedback> : null}
          </Col>
        )}
        <Col md={esOtros ? 8 : 4} className={esOtros ? '' : 'pl-0'}>
          <Field name='numeroDocumento'>
            {({ field }) => (
              <Form.InputNumber
                {...field}
                id='input-numeroDocumento'
                disabled={fIsSubmitting}
                onKeyDown={onKeyDown2}
                isInvalid={iTouchedNumero && iErrorNumero}
              />
            )}
          </Field>
          {iTouchedNumero && iErrorNumero ? <Form.Feedback type='invalid'>{iErrorNumero}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SerieNumeroFormGroup)
